<template>
  <div class="panel panel-default panel-dashboard">
    <LoadingSpinner v-if="data === null"/>

    <div v-else class="panel-body text-center">
      <div class="row">
        <div :class="breakdown === 'months' ? 'col-xs-6' : 'col-xs-8'" style="border-right: 1px solid #e1e0e0">
          <p style="font-size: 28px; margin-bottom: 0">
            {{ value | price }}
          </p>

          <p class="tw-text-gray-400 tw-mb-0" style="font-size: 12px;">
            Value
          </p>
        </div>

        <div :class="breakdown === 'months' ? 'col-xs-6' : 'col-xs-8'" style="border-right: 1px solid #e1e0e0">
          <p style="font-size: 28px; margin-bottom: 0">
            {{ count | number }}
          </p>

          <p class="tw-text-gray-400 tw-mb-0" style="font-size: 12px;">
            Partnership Orders
          </p>
        </div>

        <div :class="breakdown === 'months' ? 'col-xs-6' : 'col-xs-8'" :style="breakdown === 'months' ? 'border-right: 1px solid #e1e0e0' : ''">
          <p style="font-size: 28px; margin-bottom: 0">
                        <span v-if="valuePerPartnership">
                            {{ valuePerPartnership | price }}
                        </span>

            <span v-else>
                            N/A
                        </span>
          </p>

          <p class="tw-text-gray-400 tw-mb-0" style="font-size: 12px;">
            Value Per Partnership
          </p>
        </div>

        <div v-if="breakdown === 'months'" class="col-xs-6">
          <p style="font-size: 28px; margin-bottom: 0">
            <span v-if="valuePerMonth">
                {{ valuePerMonth | price }}
            </span>

            <span v-else>
                            N/A
                        </span>
          </p>

          <p class="tw-text-gray-400 tw-mb-0" style="font-size: 12px;">
            Value Per Month
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import moment from 'moment'
import LoadingSpinner from '@/components/Layout/LoadingSpinner'

export default {
  components: {LoadingSpinner},

  props: {
    user: {
      required: true,
      type: Object
    },

    from: {
      required: true,
      type: String
    },

    to: {
      required: true,
      type: String
    },

    breakdown: {
      required: true,
      type: String
    }
  },

  data() {
    return {
      data: null
    }
  },

  mounted() {
    this.load()
  },

  watch: {
    from() {
      this.load()
    },

    to() {
      this.load()
    },

    breakdown() {
      this.load()
    }
  },

  computed: {
    value() {
      return Math.round(this.data.reduce((total, row) => total + row.first_partnership_period_value, 0))
    },

    count() {
      return Math.round(this.data.reduce((total, row) => total + row.first_partnership_period_count, 0))
    },

    valuePerPartnership() {
      if (!this.count) {
        return null
      }

      return this.value / this.count
    },

    valuePerMonth() {
      if (!this.months) {
        return null
      }

      return this.value / this.months
    },

    months() {
      const to = moment().isBefore(this.to) ? moment() : moment(this.to)

      return to.add(1,'month').startOf('month').diff(moment(this.from).startOf('month'), 'months')
    }
  },

  methods: {
    load() {
      http.post('/api/v1/reports/new-analytics', {
        metrics: [
          {name: 'first_partnership_period_value'},
          {name: 'first_partnership_period_count'},
        ],
        dimensions: [
          {name: this.breakdown === 'months' ? 'sold_month' : 'sold_week'}
        ],
        filters: [
          {dimension: 'sold_at', operator: '>=', value: this.from},
          {dimension: 'sold_at', operator: '<=', value: this.to},
          {dimension: 'user_id', operator: '=', value: this.user.id}
        ]
      })
          .then(response => {
            this.data = response.data.data
          })
    }
  }
}
</script>
